// extracted by mini-css-extract-plugin
module.exports = {"root":"n_b","horizontal":"n_z","divider":"n_B","vertical":"n_C","dividerAnimation":"n_p"};